import '../index.css'
import {useParams, useSearchParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import Loading from "../../../components/loading";
import useScreenOrientation from "../../../hooks/orientation";
import {useSelector} from "react-redux";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import parse from "html-react-parser";
import {useTranslation} from "react-i18next";
import BeforeLoading from "../../../components/before-loading";
import './index.css'

const PlayMobile = () => {

    const {t} = useTranslation()
    const iframeRef = useRef(null)
    const {slug} = useParams()
    const [searchParams] = useSearchParams()

    const [error, setError] = useState(null)
    const [json, setJson] = useState({})
    const [game, setGame] = useState(null)
    const orientation = useScreenOrientation()
    const [gameType] = useState(searchParams.get('mode') || '')
    const [loading, setLoading] = useState(true)

    const {gameSelectedCurrency, isGameFullScreen, activeLanguage} = useSelector(state => state.globalReducer)
    const {authenticated, selectedWallet} = useSelector(state => state.authenticationReducer)

    // console.log('gameSelectedCurrency = ',gameSelectedCurrency)

    useEffect(() => {

        store.dispatch(GLOBAL_ACTIONS.setInPlayAction(true))

        setLoading(true)
        associateServices.playGame({slug, language: activeLanguage?.key}).then(res => {
            setGame(res?.data?.game)
        })

        return () => store.dispatch(GLOBAL_ACTIONS.setInPlayAction(false))
    }, [slug, authenticated, activeLanguage?.key])


    useEffect(() => {
        // console.log({
        //     gameType,
        //     code: selectedWallet?.code,
        //     id: game?.id,
        //     authenticated
        // })
        if (authenticated) {

            if (gameType && selectedWallet?.code && game?.id && gameSelectedCurrency) {
                setJson({})
                const getUrl = () => {
                    setLoading(true)
                    const value = {
                        id: game?.id,
                        currency: gameSelectedCurrency,
                        language: activeLanguage?.key,
                        type: gameType,
                        code: selectedWallet?.code,
                        device: 'mobile'
                    }
                    associateServices.getGameURL(value).then(res => {

                        if (res?.status !== 200) {
                            setLoading(false)
                            return toast.error(t(`api-notifications.${res?.errors}`))
                        }

                        try {
                            const responsed = JSON.parse(res?.data?.url)


                            const isRedirect = responsed?.gameScript.includes('location.replace');

                            if (isRedirect) {
                                const urlMatch = responsed?.gameScript.match(/location\.replace\("([^"]+)"\);/);
                                if (urlMatch && urlMatch[1]) {
                                    console.error('urlMatch[1] = ', urlMatch[1])
                                    setJson({
                                        gameHtml: `<iframe src="${urlMatch[1]}" class="iframes"/>`
                                    });
                                } else {
                                    console.log('else responsed')
                                    setJson(responsed);
                                }
                            } else {
                                setJson(responsed);
                            }

                        } catch (e) {
                            setJson({
                                gameHtml: `<iframe src="${res?.data?.url || res?.data}" class="iframes"/>`
                            });
                        }

                        setLoading(false)
                    })
                }

                getUrl()
            }
        } else if (gameType && game?.id) {
            const getUrl = () => {

                if (gameSelectedCurrency) {
                    setLoading(true)
                    const value = {
                        id: game?.id,
                        language: activeLanguage?.key,
                        currency: gameSelectedCurrency,
                        type: 'demo',
                        code: selectedWallet?.code,
                        device: 'mobile'
                    }
                    associateServices.getGameURL(value).then(res => {

                        if (res?.status !== 200) {

                            if (res?.errors === 'game-is-not-available-for-your-region' || res?.errors === 'demo-not-supported') {
                                return setError(res?.errors)
                            }
                            return toast.error(t(`api-notifications.${res?.errors}`))
                        }


                        try {
                            const responsed = JSON.parse(res?.data?.url)


                            const isRedirect = responsed?.gameScript.includes('location.replace');

                            if (isRedirect) {
                                const urlMatch = responsed?.gameScript.match(/location\.replace\("([^"]+)"\);/);
                                if (urlMatch && urlMatch[1]) {
                                    console.error('urlMatch[1] = ', urlMatch[1])
                                    setJson({
                                        gameHtml: `<iframe src="${urlMatch[1]}" class="iframes"/>`
                                    });
                                } else {
                                    console.log('else responsed')
                                    setJson(responsed);
                                }
                            } else {
                                setJson(responsed);
                            }

                        } catch (e) {
                            setJson({
                                gameHtml: `<iframe src="${res?.data?.url || res?.data}" class="iframes"/>`
                            });
                        }


                    })
                }

            }

            getUrl()
        }

    }, [gameType, game?.id, selectedWallet?.code,gameSelectedCurrency])


    useEffect(() => {
        const header = document.getElementById('header')
        const tabbar = document.getElementById('tabbar')
        const footer = document.getElementById('footer')
        const main = document.getElementById('main')
        const frameWrapper = document.getElementById('frame-wrapper')
        const frameFull = document.getElementById('frame--full')

        if (isGameFullScreen || orientation?.includes('landscape')) {
            header?.classList?.add('header--game')
            footer?.classList?.add('footer--none')
            tabbar?.classList?.add('footer--none')
            frameWrapper?.classList?.add('full--game')
            main?.classList?.add('main--game')
            frameFull?.classList?.add('fully')
        } else {

            header?.classList?.remove('header--game')
            footer?.classList?.remove('footer--none')
            tabbar?.classList?.remove('footer--none')
            main?.classList?.remove('main--game')
            frameWrapper?.classList?.remove('full--game')
            frameFull?.classList?.remove('fully')


        }
    }, [orientation, isGameFullScreen])

    useEffect(() => {
        // Inject the gameScript as a script element
        // const tester = document.getElementById('tester')
        // if (tester) {
        //
        //     if (game?.json.gameHtml)
        //         tester.innerHTML = ''
        //
        // }

        try {
            setLoading(true)
            const existing = document.getElementById('game-script')
            if (existing)
                existing?.remove()



            if (json.gameScript) {
                const script = document.createElement('script');
                script.id = "game-script"
                script.type = 'text/javascript';
                script.innerHTML = json.gameScript;

                if (game?.slug?.includes('atmosfera')) {
                    script.onload = () => {
                        // Append the script to the frame-wrapper (but only if it exists in the DOM)
                        if (iframeRef?.current) {
                            console.log('APPLY = ', script)
                            iframeRef?.current.appendChild(script);
                        }
                    }
                } else {
                    // Append the script to the frame-wrapper (but only if it exists in the DOM)
                    if (iframeRef?.current) {
                        console.log('APPLY = ', script)
                        iframeRef?.current.appendChild(script);
                        setLoading(false)
                    }
                }


                script.onerror = (err) => {
                    console.error('Script load error:', err);
                };
            } else {
                setLoading(false)
            }


        } catch (e) {
            console.error(e)
        }


    }, [json?.gameScript, json?.gameHtml, iframeRef?.current, game]);

    // console.log(gameUiURL)
    return (
        <div className="section section--frame-full">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="frame frame--full" id="frame--full">
                            <div className="frame__cover" id="frame-wrapper" ref={iframeRef}>

                                <div className="second-sort-loading">
                                    <BeforeLoading/>
                                </div>

                                {
                                    json?.gameHtml && parse(json.gameHtml)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


}

export default PlayMobile
